<lib-multi-select
	[label]="'Medications'"
	[multiSelectItems]="(medications$ | async) || []"
	[inputPlaceholder]="'Select Medications'"
	(selectionEmitter)="onSelectionEmitterEvent($event)"
></lib-multi-select>
